import {useRefetchOnAliveUpdate} from './use-refetch-on-alive-update'
import {useReviewRequestsQuery} from '../components/overview/data/route-queries'
import type {AliveChannels} from '../page-data/payloads/header'

export function useReviewersLiveUpdates(aliveChannels: AliveChannels): void {
  const {refetch} = useReviewRequestsQuery()
  useRefetchOnAliveUpdate(aliveChannels.pullRequest, refetch, {reviewers_updated: true})
  useRefetchOnAliveUpdate(aliveChannels.pullRequestState, refetch)
}
